/**
 * Sa.Reseller.Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ProductTypeEnum = 'RegioPok' | 'RegioOnlineOnly' | 'PremiumPok' | 'OnlineOnly' | 'PortalPok' | 'PortalOnlineOnly' | 'PortalPokPlus' | 'PaketBundles';

export const ProductTypeEnum = {
    RegioPok: 'RegioPok' as ProductTypeEnum,
    RegioOnlineOnly: 'RegioOnlineOnly' as ProductTypeEnum,
    PremiumPok: 'PremiumPok' as ProductTypeEnum,
    OnlineOnly: 'OnlineOnly' as ProductTypeEnum,
    PortalPok: 'PortalPok' as ProductTypeEnum,
    PortalOnlineOnly: 'PortalOnlineOnly' as ProductTypeEnum,
    PortalPokPlus: 'PortalPokPlus' as ProductTypeEnum,
    PaketBundles: 'PaketBundles' as ProductTypeEnum
};

